import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TuValorActivo() {
  const { t, i18n } = useTranslation();

  // Checkout de Hotmart de Tu Valor Activo segun el idioma de la pagina
  const checkoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/P107377103D'
      : 'https://pay.hotmart.com/W107376980U';

  const heroImage = i18n.language === 'en'
    ? 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/b1e82627-c09a-4e64-8c0c-265bd917afbf_compressed_ChatGPT-Image-18-ago-2026-06_16_22-p.m.-2.webp'
    : 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/d813de75-bd9a-4c62-950a-4f4a6816bbef_compressed_ChatGPT-Image-18-ago-2026-06_12_24-p.m.-2.webp';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('best_seller.badge')}
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                {t('bestseller_valor.hero_title1')}
                <br />
                <span className="font-bold">{t('bestseller_valor.hero_title2')}</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('bestseller_valor.hero_subtitle')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-book-open-line text-xs" />
                  {t('bestseller_valor.badge_tag')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-download-cloud-line text-xs" />
                  {t('best_seller.download')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('best_seller.unlimited')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$14.99</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('best_seller.price_label')}</span>
              </div>
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt={t('bestseller_valor.hero_image_alt')}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-sun-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-xl md:text-2xl text-cream leading-relaxed mb-6">
            {t('bestseller_valor.dark_quote')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
            <div className="w-full md:w-1/2">
              <div className="w-14 h-14 rounded-2xl bg-terracotta/15 flex items-center justify-center mb-6">
                <i className="ri-lightbulb-line text-2xl text-terracotta" />
              </div>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-6">
                {t('bestseller_valor.what_title')}
              </h2>
              <ul className="flex flex-col gap-5">
                {[1, 2, 3, 4].map((n) => (
                  <li key={n} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-terracotta/15 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-terracotta text-sm" />
                    </div>
                    <div>
                      <h3 className="font-serif text-lg font-bold text-[#8B6F5C] mb-1">
                        {t(`bestseller_valor.item_${n}_title`)}
                      </h3>
                      <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                        {t(`bestseller_valor.item_${n}_desc`)}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sand/30">
                <h3 className="font-serif text-2xl font-bold text-[#8B6F5C] mb-6">
                  {t('bestseller_valor.trilogy_title')}
                </h3>
                <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                  {t('bestseller_valor.trilogy_p1')}
                </p>
                <p className="font-sans text-sm text-[#5C4A3A] leading-relaxed">
                  {t('bestseller_valor.trilogy_p2')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-pulse-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            {t('bestseller_valor.quote')}
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            {t('bestseller_valor.quote_author')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('bestseller_valor.cta_title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('bestseller_valor.cta_desc')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$14.99</span>
            <span className="font-sans text-base text-[#5C4A3A]">USD</span>
          </div>
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-full font-sans text-base font-semibold hover:bg-brown transition-colors duration-300 mb-4 cursor-pointer"
          >
            {t('bestseller_valor.cta_button')}
            <i className="ri-arrow-right-line" />
          </a>
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('best_seller.cta_footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}